import { Component, Inject, NgModule, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { INotice, NoticeService } from 'src/services/notice.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AttachmentService, IAttachment } from 'src/services/attachment.service';
import { CommonService } from 'src/services/common.service';

@Component({
  selector: 'app-popup-dialog',
  templateUrl: './popup-dialog.component.html',
  styleUrls: ['./popup-dialog.component.css'],
})
export class PopupDialogComponent implements OnInit {
  notices: INotice;
  index: number = 0;
  slideData: any = this.data;

  slideConfig = { "slidesToShow": 1, "autoplay": true, "autoplaySpeed": 3000, "dots": true, "infinite": true, "pauseOnHover": true }; 
  constructor(
    private logger: NGXLogger,
    @Inject(MAT_DIALOG_DATA) public data: INotice,
    private attachSvc: AttachmentService,
    private commonSvc: CommonService,
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    //this.notices = this.data;

  }

  setLocalStorageWithExpiry(key, value) {
    const now = new Date().getTime();
    const item = {
      value: value,
      ttl: now + 86400000
    }
    localStorage.setItem(key, JSON.stringify(item));
  }

  FileDown(element: INotice, $event: any) {
    this.logger.log('$event', $event);
    try {
      this.commonSvc.toastMessage('파일 다운중입니다. 잠시만 기다려주세요.');      
      this.attachSvc.get(element.attachmentId)
        .subscribe(res => {
          this.attachSvc.download(res);
        })

    } catch (err) {
      this.logger.error(`failed to upload file, ${err}`);
      this.commonSvc.toastMessage('파일 다운에 실패하였습니다. 다시 시도해주세요.');
    }

  }

}
